import type { WebKilnApiClient } from './api-client';
import type { Workspace } from './contracts';

export function renderWorkspaceSetup(
  container: HTMLElement,
  cloud: WebKilnApiClient,
  onCreated: (workspace: Workspace) => void,
): void {
  container.innerHTML = `<section class="dashboard-panel workspace-setup"><p class="eyebrow">First, your workspace</p><h2>Create your workspace.</h2><p>A workspace keeps your websites and team together. You can create a website next.</p><form class="cloud-form" data-workspace-form><label>Workspace name<input name="workspaceName" autocomplete="organization" required maxlength="80" placeholder="Your business or team" /></label><p class="cloud-error" data-workspace-error role="alert" hidden></p><button class="primary-btn" type="submit">Create workspace</button></form></section>`;
  const form = container.querySelector<HTMLFormElement>('form')!;
  const button = form.querySelector<HTMLButtonElement>('button')!;
  const error = form.querySelector<HTMLElement>('[data-workspace-error]')!;
  const input = form.querySelector<HTMLInputElement>('input')!;
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (button.disabled) return;
    const name = input.value.trim();
    input.setCustomValidity(name ? '' : 'Enter a workspace name.');
    if (!form.reportValidity()) return;
    error.hidden = true;
    button.disabled = true;
    button.textContent = 'Creating workspace…';
    try {
      const workspace = await cloud.createWorkspace(name);
      onCreated(workspace);
    } catch (createError) {
      error.textContent =
        createError instanceof Error ? createError.message : 'Could not create workspace.';
      error.hidden = false;
      button.disabled = false;
      button.textContent = 'Create workspace';
    }
  });
  input.addEventListener('input', () => input.setCustomValidity(''));
}
